let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cPBME")).then(() => parcelRequire('br2f9'));